(function () {
  'use strict';

  angular.module('app').component('tourPriceDetail', tourPriceDetail());

  function tourPriceDetail() {
    return {
      bindings: {
        tourPrices: '=',
        tour: '=',
        paxRanges: '=',
        seasonSelected: '=',
        priceListSelected: '=',
        onTourPricesSaved: '&',
        onTourPricesCanceled: '&',
      },
      controller: TourPriceDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tour-prices/tour-price-detail/tour-price-detail.component.html',
    };
  }

  TourPriceDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TourPriceService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function TourPriceDetailComponent(config, UtilService, TourPriceService, paxRangeService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.selectPaxRange = selectPaxRange;

    vm.saveTourPrices = saveTourPrices;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          selectPaxRange(item);
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          selectPaxRange(paxRangeToSelect);
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.tourPrices.length > 0) {
        // Edit and exists prices
        setPaxRangesSelected();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.tourPrices[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_PRICES';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_PRICES';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setPaxRangesSelected() {
      vm.paxRangesSelected = [];

      vm.tourPrices.forEach(function (tourPrice) {
        vm.paxRanges.forEach(function (paxRange) {
          if (!checkIfPaxRangeExist(paxRange) && tourPrice.pax_range_id === paxRange.id) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Seta all prices from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.paxRangesDataPrices = [];

      vm.paxRanges.forEach(function (paxRange) {
        paxRange.tour_options = [];

        vm.tour.tour_options.forEach(function (tourOption) {
          // loop for the tour options of the selected tour
          var option = {
            id: tourOption.id,
            name: tourOption.name,
            status: tourOption.status,
            tour_option_schedules: [],
          };

          tourOption.tour_option_schedules.forEach(function (tourOptionSchedule) {
            // loop for the tour option schedules.
            var schedule = setTourOptionSchedule(tourOption, tourOptionSchedule, paxRange);
            option.tour_option_schedules.push(schedule);
          });

          paxRange.tour_options.push(option);
        });

        vm.paxRangesDataPrices.push(paxRange);
      });
    }

    // Gets the Tour options schedule for the selected tour and pax range
    function setTourOptionSchedule(tourOption, tourOptionSchedule, paxRange) {
      var tourPriceId;
      var adultPrice = '',
        childPrice = 0,
        infantPrice = 0,
        seniorPrice = 0;

      // Exist tour prices
      if (vm.tourPrices.length > 0) {
        for (var i = 0; i < vm.tourPrices.length; i++) {
          var tourPrice = vm.tourPrices[i];

          if (
            tourPrice.pax_range_id === paxRange.id &&
            tourPrice.tour_option_id === tourOption.id &&
            tourPrice.tour_option_schedule_id === tourOptionSchedule.id
          ) {
            tourPriceId = tourPrice.id;

            adultPrice = tourPrice.adult_price;
            childPrice = tourPrice.child_price;
            infantPrice = tourPrice.infant_price;
            seniorPrice = tourPrice.senior_price;
            break;
          }
        }
      }

      var schedule = {
        id: tourOptionSchedule.id,
        departure: tourOptionSchedule.departure,
        status: tourOptionSchedule.status,
        adult_price: adultPrice,
        child_price: childPrice,
        infant_price: infantPrice,
        senior_price: seniorPrice,
        tourPriceId: null,
      };

      if (tourPriceId) {
        schedule.tourPriceId = tourPriceId;
      }

      return schedule;
    }

    function saveTourPrices(isFormValid) {
      if (!isFormValid || vm.tour.tour_options.length === 0) {
        return;
      }

      var tourPrices = [];

      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        var paxRangeSelected = vm.paxRangesSelected[i];

        for (var j = 0; j < vm.paxRangesDataPrices.length; j++) {
          var paxRangeData = vm.paxRangesDataPrices[j];

          if (paxRangeData.id === paxRangeSelected.id) {
            paxRangeData.tour_options.forEach(function (tourOption) {
              tourOption.tour_option_schedules.forEach(function (tourOptionSchedule) {
                var price = {
                  adult_price: tourOptionSchedule.adult_price || 0,
                  child_price: tourOptionSchedule.child_price || 0,
                  infant_price: tourOptionSchedule.infant_price || 0,
                  senior_price: tourOptionSchedule.senior_price || 0,

                  tour_option_id: tourOption.id,
                  tour_option_schedule_id: tourOptionSchedule.id,
                  pax_range_id: paxRangeSelected.id,
                  id: null,
                };

                if (tourOptionSchedule.tourPriceId) {
                  price.id = tourOptionSchedule.tourPriceId;
                }

                tourPrices.push(price);
              });
            });

            break; // check
          }
        }
      }

      var params = {
        tour_prices: tourPrices,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
      };

      vm.sendingForm = true;
      TourPriceService.saveTourPrices(vm.tour, params, vm.editMode).then(function (data) {
        if (data) {
          vm.onTourPricesSaved();

          setItemOptions(data[0].updated_at);

          vm.tourPrices = data;
          setPaxRangesData();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onTourPricesCanceled();
    }
  }
})();
